var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M34.5,21.7c3.9,0,7-3.1,7-7c0-3.9-3.1-7-7-7c-3.9,0-7,3.1-7,7h0.8c0-3.4,2.8-6.2,6.2-6.2 c3.4,0,6.2,2.8,6.2,6.2c0,3.4-2.8,6.2-6.2,6.2H3.5v0.8H34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M18.1,16.2H3.5v0.9h14.6c2.4-0.1,4.3-2,4.3-4.4c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.4,4.3h0.9 c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5c0,0,0,0,0,0C21.6,14.6,20.1,16.2,18.1,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M22.3,36.7c3,0,5.5-2.5,5.5-5.5c0-3-2.5-5.5-5.5-5.5H3.5v0.8h18.7c1.9,0.1,3.6,1.2,4.4,2.9 c0.7,1.8,0.3,3.8-1.1,5.2c-1.4,1.3-3.4,1.7-5.1,1c-1.8-0.7-2.9-2.5-2.9-4.4h-0.8C16.8,34.2,19.2,36.7,22.3,36.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.3eb6d3d3a9653ea691ae544adb611763.svg";
export { ForwardRef as ReactComponent };